import stringify from 'json-stringify-pretty-compact';

export function formatJson(jsonString: string | null): string {
  if (!jsonString) {
    return 'No message available';
  }
  try {
    return stringify(JSON.parse(jsonString))
  } catch {
    return jsonString;
  }
}


